// export const node_url = 'http://192.168.1.2:3005/'
// export const node_url = 'https://www.erp2.webamplifierapps.com/'
export const node_url = window.location.origin + '/'
export const url = node_url + 'api/';
export const GST = ['0%', '8%', '12%', '18%'];

export function formatDate(date_sting) {
    const date_array = date_sting.split('-');
    return `${date_array[2]}-${date_array[1]}-${date_array[0]}`
}
export function formatDateTime(date_sting) {
    const date_array = date_sting.split(' ');
    const date_array_1 = date_array[0].split('-');
    return `${date_array_1[2]}-${date_array_1[1]}-${date_array_1[0]}`
}

export const currency_list = ["KWD","INR","USD","YUAN","DIRHAM"]
